{
  "articles": [
    {
      "title": "Consultations with experts",
      "description": "Support of experienced dieticians, psychologists, trainers and physiotherapists",
      "image": "/images/articles/article-1.jpg",
      "date": "",
      "author": {
        "name": ""
      },
      "url": {
        "pl-PL" : "",
        "en-US": ""
      }
    },
    {
      "title": "Body mass measurements",
      "description": "A diet and exercise routine adapted strictly to the needs",
      "image": "/images/articles/article-2.jpg",
      "date": "",
      "author": {
        "name": ""
      },
      "url": {
        "pl-PL" : "",
        "en-US": ""
      }
    },
    {
      "title": "Ergonomic workshops",
      "description": "Practical tips and exercises",
      "image": "/images/articles/article-3.jpg",
      "date": "",
      "author": {
        "name": ""
      },
      "url": {
        "pl-PL" : "",
        "en-US": ""
      }
    },
    {
      "title": "Physiotherapy workshops",
      "description": "Expert knowledge and experience offered in an accessible format",
      "image": "/images/articles/article-4.jpg",
      "date": "",
      "author": {
        "name": ""
      },
      "url": {
        "pl-PL" : "",
        "en-US": ""
      }
    }
  ]
}